import { useSnackbar } from 'notistack';
import { useCallback } from 'react';

import { useCreateJobSuggestionMutation } from '@libs/graphql-types';
import { FormikSubmit } from '@libs/helpers/form';

import { IFormState } from './propose-modal/types';

export const useProposeHandler = ({
  onSuccess,
  jobId,
}: {
  onSuccess: VoidFunction;
  jobId: string;
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [request, { loading }] = useCreateJobSuggestionMutation({
    onCompleted: () => {
      enqueueSnackbar('Success!', { variant: 'success' });
    },
  });

  const onSubmit: FormikSubmit<IFormState> = useCallback(
    async (values) => {
      const res = await request({
        variables: {
          job_id: jobId,
          email: values.email,
          first_name: values.firstName,
        },
      });

      if (res.data?.createJobSuggestion) {
        onSuccess();
      }
    },
    [jobId, onSuccess, request],
  );

  return { onSubmit, isLoading: loading };
};
